import React from "react";
import { PanelCard } from "@sonder/ui/source/styled/fragments/PanelCard";
import { TaskData } from "core/queries/GetTask";
import { TaskChecklist } from "tasks/components/TaskPanel/Details/TaskChecklist";

export const ChecklistCard = ({ task }: { task: TaskData }) => (
  <PanelCard>
    <TaskChecklist task={task} />
  </PanelCard>
);
